/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect, useRef } from "react";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, FormControl, Grid, Modal } from "react-bootstrap";
import Card from "Front/components/Card/Card.jsx";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import * as API from "../../../api/nextVisitInstructions";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Loading from "react-loading";
import moment from "moment";
import AddEditNextVisitInstruction from "./AddEditNextVisitInstruction";
import NotificationSystem from "react-notification-system";
import { style } from "Admin/variables/Variables.jsx";



const NextVisitInstructions = () => {
    const [formData, setFormData] = useState({ limit: 10, page: 0, direction: 'asc', search: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [nextVisitInstructionList, setNextVisitInstructionList] = useState([]);
    const [modalStatus, setModalStatus] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [showModal, setShowModal] = useState(false)
    const [selectedRowData, setSelectedRowData] = useState(false)
    const [mode, setMode] = useState("add")
    const notificationSystem = useRef(null);

    const getList = async (from = {}) => {
        setIsLoading(true);
        try {
            let resp = await API.getNextVisitInstructionList({
                limit: formData.limit,
                offset: formData.page,
                order: "createdAt",
                clinicId: localStorage.getItem("clinicId"),
                direction: formData.direction,
                "search": from.search
            });
            if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
                setIsLoading(false);
                setNextVisitInstructionList(resp.data.data.data);
                setTotalCount(resp.data.data.count);
            }
        }
        catch (error) {
            console.log(error, "-------------error")
        }
    };

    useEffect(() => {
        getList();
    }, []);

    const handleChange = (e, field = "") => {
        if (e !== "") {
            if (e.length >= 1) {
                let saveFormData = formData;
                saveFormData[field] = e;
                saveFormData["page"] = 0;
                setFormData({ ...formData, ...saveFormData });
                getList(saveFormData);
            }
        } else {
            let saveFormData = formData;
            saveFormData[field] = e;
            saveFormData["page"] = 0;
            setFormData({ ...formData, ...saveFormData });
            getList(saveFormData);
        }
    };

    const srNo = (cell, row, enumObject, rowIndex) => {
        return rowIndex + 1 + formData.limit * formData.page;
    };

    const _setTableOption = () => {
        if (isLoading) {
            return (
                <Loading
                    type="bars"
                    color="#000000"
                    style={{ margin: "0px auto", width: "40px" }}
                />
            );
        } else {
            return "No data found!";
        }
    };

    const onPageChange = (page, sizePerPage) => {
        let data = formData;
        data["page"] = page - 1;
        data["limit"] = sizePerPage;
        setFormData({ ...formData, ...data });
        getList(data);
    };

    const rowStyleFormat = (row, rowIdx) => {
        if (row && row.visited) {
            return { backgroundColor: "#f3f1b0" };
        }
    };

    const options = {
        //onSortChange: this.onSortChange,
        clearSearch: true,
        pageStartIndex: 1, // where to start counting the pages
        paginationSize: 3, // the pagination bar size.
        prePage: "Prev", // Previous page button text
        nextPage: "Next", // Next page button text
        firstPage: "First", // First page button text
        lastPage: "Last", // Last page button text
        //paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
        paginationPosition: "bottom", // default is bottom, top and both is all available
        sizePerPage: formData.limit,
        onPageChange: onPageChange,
        page: formData.page + 1,
        noDataText: _setTableOption(),
    };

    const actionButton = (cell, row, enumObject, rowIndex) => {
        return (<span>
            {row.type === "clinic" &&
                <>
                    <i style={{ cursor: "pointer" }} className="fa fa-pencil" onClick={e => setRowData(row)} aria-hidden="true"></i>
                    &nbsp;&nbsp; &nbsp;&nbsp;
                    <i style={{ cursor: "pointer" }} className={!row.isDeleted ? ('fa fa-check') : ('fa fa-remove')} onClick={e => statusChangedHandler(row)} aria-hidden="true"></i>
                </>
            }
            {/*&nbsp;&nbsp; &nbsp;&nbsp;
            <i class="fa fa-trash" aria-hidden="true" onClick={e => getConfirmFun(row._id)}></i> */}
        </span>)
    }

    const setRowData = (row) => {
        console.log(row, "------------row")
        setMode("edit")
        setShowModal(true)
        setSelectedRowData(row)
    }

    const successAlert = (msg) => {
        const notification = notificationSystem.current;
        notification.addNotification({
            title: (
                <span
                    data-notify="icon"
                    className="pe-7s-check"
                    style={{
                        fontSize: "30px",
                        color: "#fff",
                        padding: "0px !important",
                        top: "0% !important",
                    }}
                ></span>
            ),
            message: <div>{msg}</div>,
            level: "success",
            position: "tr",
            autoDismiss: 2,
        });
    }

    const resetRowData = (callApi) => {

        setShowModal(false)
        setSelectedRowData(null)
        if (callApi) {
            successAlert(mode === "add" ? "Next Visit Instruction added Successfully" : "Next Visit Instruction Updated Successfully");
            getList()
        }
        setMode("add")
    }

    const statusChangedHandler = async (row) => {
        let sentData = new FormData();
        sentData.append("id", row?._id);
        sentData.append("isDeleted", !row?.isDeleted);
        try {
            let resp = await API.updateNextVisitInstruction(sentData);
            if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
                successAlert(!row?.isDeleted ? "Next Visit Instruction Disabled Successfully" : "Next Visit Instruction Enabled Successfully");
                getList()
            }
        } catch (error) {
            console.log(error, "-----------error")
        }
    }

    return (
        <>
            <NotificationSystem ref={notificationSystem} style={style} />
            <div className="fresh-datatables   table-responsive-new-withoutScroll">
                <Row className="search-section">
                    <Col sm={6} md={4} className="form-group">
                        <FormControl
                            type="text"
                            autocomplete="off"
                            name="search"
                            id="search"
                            value={formData.search ? formData.search : ""}
                            onChange={(e) => {
                                handleChange(e.target.value, "search");
                            }}
                            placeholder="Search here ..."
                        />
                    </Col>
                    <Col sm={6} md={4} style={{ float: "right" }} className="form-group">
                        <AddEditNextVisitInstruction mode={mode} data={selectedRowData} ModalStatus={showModal} resetRowData={resetRowData} setModalStatus={setShowModal} /></Col>
                </Row>
                <div className="fresh-datatables dashboard table-responsive row">
                    <BootstrapTable
                        deleteRow={false}
                        key={nextVisitInstructionList}
                        data={nextVisitInstructionList}
                        search={false}
                        pagination={true}
                        options={options}
                        striped
                        hover
                        condensed
                        scrollTop={"Bottom"}
                        remote={true}
                        fetchInfo={{ dataTotalSize: totalCount }}
                        sort={true}
                        trStyle={rowStyleFormat}
                    >
                        <TableHeaderColumn
                            hidden={true}
                            tdAttr={{ "data-attr": "_id" }}
                            dataField="_id"
                            dataSort={true}
                            isKey={true}
                            searchable={false}
                        >
                            Id
                        </TableHeaderColumn>

                        <TableHeaderColumn
                            tdAttr={{ "data-attr": "#" }}
                            thStyle={{ width: "30px", textAlign: "center" }}
                            tdStyle={{ width: "30px", textAlign: "center" }}
                            dataField="sn"
                            dataFormat={srNo}
                        >
                            S.No.
                        </TableHeaderColumn>

                        <TableHeaderColumn
                            tdAttr={{ "data-attr": "instruction" }}
                            thStyle={{ width: "150px", textAlign: "center" }}
                            tdStyle={{ width: "150px", textAlign: "center" }}
                            dataField="instruction"
                        >
                            Instruction
                        </TableHeaderColumn>

                        <TableHeaderColumn
                            tdAttr={{ "data-attr": "type" }}
                            thStyle={{ width: "50px", textAlign: "center" }}
                            tdStyle={{ width: "50px", textAlign: "center" }}
                            dataField="type"
                        >
                            Type
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            thStyle={{ width: "50px", textAlign: "center" }}
                            tdStyle={{ width: "50px", textAlign: "center" }}
                            tdAttr={{ "data-attr": "_id" }}
                            dataFormat={actionButton}
                        >
                            Action
                        </TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        </>

    )
}

export default NextVisitInstructions